import { render, staticRenderFns } from "./CreditorListSideMenu.vue?vue&type=template&id=c740f262"
import script from "./CreditorListSideMenu.vue?vue&type=script&lang=js"
export * from "./CreditorListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports